import React from 'react';

const Input = ({
  id = 'default-id',
  value = '',
  placeholder = 'Escribe aquí...',
  className = '',
  onChange,
  ...rest
}) => {
  return (
    <input
      id={id}
      value={value}
      onChange={onChange}
      className={`w-full px-3 py-2 border border-gray-300 rounded-md shadow-md ${className}`}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default Input;
